// Waiting-on-you queue helpers (filter, search, grouping) — parity with HelmStore.filteredWaiting / MainWindow.groups.
import type { WaitingItem } from './types';

export type WaitingFilter = 'all' | 'approvals' | 'items' | 'escalated';
export const WAITING_FILTERS: { id: WaitingFilter; label: string }[] = [
  { id: 'all', label: 'All' }, { id: 'approvals', label: 'Approvals' }, { id: 'items', label: 'Items' }, { id: 'escalated', label: 'Over 72 h' },
];

export function filterWaiting(items: WaitingItem[], filter: WaitingFilter, query: string): WaitingItem[] {
  const q = query.trim().toLowerCase();
  return items.filter((w) => {
    if (filter === 'approvals' && w.item !== 'approval') return false;
    if (filter === 'items' && w.item !== 'initiative') return false;
    if (filter === 'escalated' && w.escalation !== 'escalate') return false;
    if (!q) return true;
    return [w.key, w.title, w.projectName, w.detail, w.kind, w.rec].some((f) => (f ?? '').toLowerCase().includes(q));
  });
}

/** Group by project, biggest group first (ties alphabetical). */
export function groupByProject(items: WaitingItem[]): [string, WaitingItem[]][] {
  const m = new Map<string, WaitingItem[]>();
  for (const w of items) { const k = w.projectName ?? 'No project'; (m.get(k) ?? m.set(k, []).get(k)!).push(w); }
  return [...m.entries()].sort((a, b) => (a[1].length === b[1].length ? a[0].localeCompare(b[0]) : b[1].length - a[1].length));
}

export const SNOOZE_CHOICES: { hours: number; label: string }[] = [
  { hours: 4, label: '4 hours' }, { hours: 24, label: '1 day' }, { hours: 72, label: '3 days' }, { hours: 168, label: '1 week' },
];
